import { render } from "./prescription_view_modal.vue?vue&type=template&id=6fa6f768"
import script from "./prescription_view_modal.vue?vue&type=script&lang=js"
export * from "./prescription_view_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__